import React, { useEffect, useState } from "react";
import { invoiceApi, apiError } from "../../api/lab";
import { useApp } from "../../AppProvider";
import { Modal, Button, Field } from "../../Components/UI/ui";
import { PAYMENT_METHODS, money, todayStr } from "../../lib/lab";

// POST /labInvoices/:id/payment
const PaymentModal = ({ open, onClose, invoice, onSaved }) => {
  const { toast } = useApp();
  const outstanding = invoice ? (invoice.outstanding ?? (invoice.grandTotal - (invoice.totalPaidAmount || 0))) : 0;
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("UPI");
  const [note, setNote] = useState("");
  const [date, setDate] = useState(todayStr());
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (open) { setAmount(outstanding > 0 ? String(outstanding) : ""); setMethod("UPI"); setNote(""); setDate(todayStr()); setErr(null); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, invoice?._id]);

  const submit = async () => {
    const amt = Number(amount);
    if (!(amt > 0)) return setErr("Enter an amount greater than 0");
    if (amt > outstanding + 0.005) return setErr(`Amount exceeds outstanding ${money(outstanding)}`);
    setSaving(true); setErr(null);
    try {
      const res = await invoiceApi.addPayment(invoice._id, { amount: amt, paymentMethod: method, note: note.trim(), date: new Date(date).toISOString() });
      toast.success(`Payment of ${money(amt)} recorded`);
      onSaved?.(res?.data ?? res);
      onClose();
    } catch (e) {
      setErr(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  if (!invoice) return null;
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      title={`Record payment · ${invoice.invoiceNumber || ""}`}
      footer={
        <>
          {err && <span className="lab-danger-text" style={{ marginRight: "auto" }}>{err}</span>}
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" loading={saving} onClick={submit}>Record</Button>
        </>
      }
    >
      <div className="lab-total"><span>Grand total</span><span>{money(invoice.grandTotal)}</span></div>
      <div className="lab-total"><span>Paid so far</span><span>{money(invoice.totalPaidAmount || 0)}</span></div>
      <div className="lab-total grand"><span>Outstanding</span><span>{money(outstanding)}</span></div>
      <div className="lab-grid cols-2">
        <Field label="Amount"><input type="number" min="0" step="0.01" className="lab-input" value={amount} onChange={(e) => setAmount(e.target.value)} autoFocus /></Field>
        <Field label="Method">
          <select className="lab-select" value={method} onChange={(e) => setMethod(e.target.value)}>
            {PAYMENT_METHODS.map((m) => <option key={m}>{m}</option>)}
          </select>
        </Field>
        <Field label="Date"><input type="date" className="lab-input" value={date} onChange={(e) => setDate(e.target.value)} /></Field>
        <Field label="Note"><input className="lab-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Txn ref, card last 4…" /></Field>
      </div>
    </Modal>
  );
};

export default PaymentModal;
